import React from "react";
import { Button, Select } from "antd";
import { Plus } from "lucide-react";
import { DataTable } from "../../components/DataTable";
import { IArtist } from "../../../types/api/artist";
import { getArtistColumns } from "./ArtistColumns";

const SORT_OPTIONS = [
  { label: "Sort: Newest First", value: "" },
  { label: "Name: A-Z", value: "name_asc" },
  { label: "Name: Z-A", value: "name_desc" },
];

interface ArtistPanelProps {
  title: React.ReactNode;
  addLabel: string;
  list: IArtist[];
  total: number;
  loading: boolean;
  isError: boolean;
  queryData: any;
  search: string;
  onSearchChange: (v: string) => void;
  statusFilter: string;
  onStatusChange: (v: string) => void;
  sortBy?: string;
  onSortChange?: (v: string) => void;
  onPageChange: (page: number, limit: number) => void;
  onAdd: () => void;
  onEdit: (record: IArtist) => void;
  onDelete: (id: string) => void;
  extraHeaderActions?: React.ReactNode;
}

export const ArtistPanel: React.FC<ArtistPanelProps> = ({
  title,
  addLabel,
  list,
  total,
  loading,
  isError,
  queryData,
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  sortBy = "",
  onSortChange,
  onPageChange,
  onAdd,
  onEdit,
  onDelete,
  extraHeaderActions,
}) => {
  const columns = getArtistColumns({
    onEdit,
    onDelete,
  });

  return (
    <DataTable
      title={title}
      headerActions={
        <div className="flex items-center gap-2">
          {extraHeaderActions}
          <Button
            type="primary"
            size="small"
            icon={<Plus size={16} />}
            onClick={onAdd}
            className="!bg-primary flex items-center gap-2"
          >
            {addLabel}
          </Button>
        </div>
      }
      dataSource={list}
      columns={columns}
      loading={loading}
      isError={isError}
      rowKey="_id"
      searchProps={{
        searchValue: search,
        onSearchChange,
        placeholder: "Search artists...",
        statusValue: statusFilter,
        onStatusChange,
        children: onSortChange ? (
          <Select
            value={sortBy}
            onChange={onSortChange}
            options={SORT_OPTIONS}
            className="w-40 h-[35px]"
          />
        ) : undefined,
      }}
      paginationProps={
        queryData
          ? {
              page: queryData.page ?? 1,
              limit: queryData.limit ?? 10,
              total,
              onChange: (page: number, pageSize: number) => onPageChange(page, pageSize),
            }
          : undefined
      }
    />
  );
};
